import { jsx as _jsx } from "react/jsx-runtime";
import { createIcon, } from '@chakra-ui/react';
import { ThemeIconSizeVariable, } from '@caspeco/casper-ui-library.base-ui.theme';
import { Icons } from './types';
function getKeyFromEnumValue(icon, type) {
    return Object.keys(Icons).find((key) => type[key] === icon) ?? '';
}
export const Icon = ({ icon, size = ThemeIconSizeVariable.Medium, ...props }) => {
    const iconKey = getKeyFromEnumValue(icon, Icons);
    const defaultProps = {
        width: size,
        height: size,
    };
    if (iconKey === 'Caspeco') {
        defaultProps.fillRule = 'evenodd';
        defaultProps.clipRule = 'evenodd';
    }
    const IconComponent = createIcon({
        displayName: iconKey,
        viewBox: '0 0 20 20',
        d: icon,
        defaultProps,
    });
    return _jsx(IconComponent, { ...props });
};
//# sourceMappingURL=icon.js.map